<!--
    @Author : Luo
    @Time   : 2020/9/25 9:44
-->
<template>
  <div class="account_analysis_page">
    <div :class="'page_nav' + (!catAccountStatus ? ' page_nav_full' : '')">
      <div class="page_nav_header flex_center">
        <template v-if="catAccountStatus">
          <router-link :to="{path: '/home/user/index', query: {team: teamIndex}}">
            <span>账号概览</span>
          </router-link>
        </template>
        <template v-else>
          <router-link :to="{path: '/home/user/index', query: {account: 'true', team: catUserInfo['team'], id: catUserInfo['id'], name: catUserInfo['name']}}">
            <span>账号概览</span>
          </router-link>
        </template>
        <div class="page_nav_breadcrumb"><span>/</span></div>
        <div class="now_page_label">
          <span>子集列表</span>
        </div>
      </div>
      <div class="page_nav_content flex_center">
        <div class="account_info_item flex_center">
          <div class="account_info_container flex_center account_user" v-if="accountDate.firstname && accountDate.firstname.length > 0">
            <div class="account_label">
              <span>用户名</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.firstname }}</span>
            </div>
          </div>
          <div class="account_info_container flex_center account_user" v-if="accountDate.account && accountDate.account.length > 0">
            <div class="account_label">
              <span>账号</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.account }}</span>
            </div>
          </div>
          <div class="account_info_container flex_center account_user" v-if="accountDate.nickname && accountDate.nickname.length > 0">
            <div class="account_label">
              <span>微信名</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.nickname }}</span>
            </div>
          </div>
        </div>
        <div class="account_info_item flex_center">
          <div class="account_info_container flex_center account_channel">
            <div class="account_label flex_center">
              <span>渠道</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.channel }}</span>
            </div>
          </div>
          <div class="account_info_container flex_center account_label_note">
            <div class="account_label flex_center">
              <span>人名/机构名</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.label }}</span>
            </div>
          </div>
          <div class="account_info_container flex_center account_create">
            <div class="account_label">
              <span>生成时间</span>
            </div>
            <div class="account_info_content flex_center">
              <span>{{ accountDate.time }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="account_page_container">
      <div class="account_page_header flex_center">
        <div class="page_wait_time">
          <div class="page_wait_time_container flex_center">
            <div class="page_wait_time_info"><span>{{ shareTime }}</span></div>
            <div class="page_wait_time_label"><span>分享次数</span></div>
          </div>
        </div>
        <div class="account_page_search flex_center">
          <div class="input_container">
            <select @change="setTeam" v-model="teamIndex">
              <option v-for="(item, i) of teamDate" :key="i"
                      :value="item.id">{{ item.name }}</option>
            </select>
          </div>
          <div class="time_container flex_center">
            <div class="time_input">
              <input id="range_time" ref="range_time" placeholder="时间范围" readonly type="text" v-model="browseTimeDate" />
            </div>
          </div>
        </div>
      </div>
      <div class="account_page_main text_left">
        <div class="account_page_main_header flex_center">
          <div class="account_page_main_client"><span>子账号</span></div>
          <div class="account_page_main_member"><span>浏览时间</span></div>
        </div>
        <div class="account_page_main_list flex_center">
          <div class="no_user_hint text_center" v-if="JSON.stringify(tempClientDate).length <= 2"><span>{{ noDataHint }}</span></div>
          <div class="account_page_main_client_container flex_center" v-for="(item, i) in tempClientDate['current' + pagination.current]" :key="i">
            <div class="account_page_main_client"><span>{{ (item.firstname && item.firstname.length > 0) ? item.firstname : ((item.castName && item.castName.length > 0) ? item.castName : item.nickname) }}</span><span v-if="item.register" class="user_identification">游客注册</span></div>
            <div class="account_page_main_member"><span>{{ item.createTime }}</span></div>
          </div>
        </div>
      </div>
      <div>
        <pagination :key="pagination.length" :default-current="pagination.current" :length="pagination.length" :default-amount="pagination.amount" v-on:pageCurrent="pageCurrent" />
      </div>
    </div>
  </div>
</template>

<script>
import pagination from '@/components/pagination/index'
import { _Ajax, initLogin, logout } from '@/api/_axios'
import { newMap, setTimeType, resetSpecNum } from '@/components/common/common_js'

export default {
  name: 'clientFromQr',
  components: {
    pagination
  },
  data () {
    return {
      title: '',
      setTimeType: setTimeType,
      resetSpecNum: resetSpecNum,
      accountDate: {}, // 账号数据
      pageTotalTime: {all: 0, top: 0},
      browseTimeDate: '', // 浏览时间范围
      clientDate: [], // 子账号数据
      tempClientDate: {}, // 子账号分页数据
      noDataHint: '',
      shareTime: 0, // 分享次数
      layDate: window.laydate, // 时间插件
      pagination: {
        length: 0,
        amount: 10,
        current: 1
      },
      teamIndex: null,
      teamDate: [],
      catAccountStatus: true,
      catUserInfo: {}
    }
  },
  computed: {
    // 设置时间格式
    timeType: function () {
      return (time, str) => {
        return time.getFullYear() + str + (time.getMonth() + 1) + str + (time.getDate() > 10 ? time.getDate() : '0' + time.getDate())
      }
    },
    // 计算时间的上一周或者下一周
    setTimeRange: function () {
      return (time, str) => {
        return str === 'prev' ? new Date(new Date(time).getTime() - 6 * 24 * 60 * 60 * 1000)
          : new Date(new Date(time).getTime() + 6 * 24 * 60 * 60 * 1000)
      }
    }
  },
  methods: {
    setClient: function () {
      this.getClientPageDate(this.accountId,
        this.clientSelect.index === 0 ? undefined : this.clientSelect.index,
        this.pageSelect.index === 0 ? undefined : this.pageSelect.index)
    },
    setPage: function () {
      this.getClientPageDate(this.accountId,
        this.clientSelect.index === 0 ? undefined : this.clientSelect.index,
        this.pageSelect.index === 0 ? undefined : this.pageSelect.index)
    },
    // 设置客户的数据 arr: 数组, amount: 条目
    setUserDate: function (arr) {
      let tempArr = []
      let amount = this.pagination.amount
      let tempAmount = Math.ceil(this.pagination.length / amount)
      this.tempClientDate = {}
      for (let i = 1; i <= tempAmount; i++) {
        newMap(arr, (e, j) => {
          if (amount * ((i - 1) <= 0 ? 0 : i - 1) <= j && amount * i > j) {
            tempArr.push(e)
          }
        })
        this.tempClientDate['current' + i] = tempArr
        tempArr = []
      }
    },
    pageCurrent: function (data) {
      this.pagination.current = data.current
      // 选择每页显示条数的时候在刷新列表、条目及组件
      if (data.event === 'amount') {
        this.pagination.amount = data.amount
        this.setUserDate(this.clientDate)
      }
    },
    // 获取该账号下二维码客户数据
    getClientPageDate: function (id) {
      let that = this

      // 时间
      let time = that.setChangeTimeRange(that.browseTimeDate)

      that.clearUserData()

      _Ajax(
        {
          method: 'post',
          url: '/data/overview/channel',
          clearCancelSource: true,
          params: {
            id: id,
            startTime: time[0],
            endTime: time[1]
          }
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '账号概览 - 页面分析：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            res = res.data
            if (res.code && res.code === 'err100104') {
              that.noDataHint = '暂无客户数据'
              that.$notice({type: 'error', content: `错误：该用户的子集${res.msg}`})
              return false
            }
            that.accountDate = {
              account: res.userName,
              channel: Number(res.canal) === 1 ? '个人' : '渠道',
              label: res.label,
              time: res.createTime,
              firstname: res.firstname,
              nickname: res.nickname
            }
            that.shareTime = res.channelFrequency
            // channelStayList[i].castName: 游客+四位随机数+id（由后台操作）
            that.clientDate = res.channelStayList
            that.pagination.length = that.clientDate.length

            if (that.pagination.length <= 0) {
              that.noDataHint = '暂无客户数据'
            }

            that.pagination.current = 1
            that.setUserDate(that.clientDate)
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    },
    // 时间范围的初始化
    getClientDate: function () {
      let that = this
      that.combinationLayDate('#range_time', 'date', that.browseTimeDate,
        (v) => {
          that.browseTimeDate = v
          that.getClientPageDate(that.accountId)
        }
      )
    },
    // 时间范围转换为开始和结束
    setChangeTimeRange: function (str) {
      if (str.indexOf('~') > 0) {
        return [str.split('~')[0].trim(), str.split('~')[1].trim()]
      } else {
        return ''
      }
    },
    // 封装laydate
    combinationLayDate: function (el, type, val, res) {
      this.layDate.render({
        elem: el,
        trigger: 'click',
        type: type,
        range: '~',
        value: val,
        done: function (val) {
          res(val)
        }
      })
    },
    // 清空数据
    clearUserData: function () {
      let that = this
      that.noDataHint = '数据正在加载中...'
      that.pagination.length = 0
      that.clientDate = []
      that.setUserDate(that.clientDate)
    },
    // 选择账号的有效性
    setTeam: function () {
      console.log(this.teamIndex)
    }
  },
  mounted () {
    this.getClientDate()

    this.getClientPageDate(this.accountId)
  },
  beforeMount: function () {
    let that = this
    let tempRoute = that.$route.query

    that.teamIndex = tempRoute.team
    that.accountId = tempRoute.id
    that.teamIndex = 0
    that.teamDate = [
      {name: '有效', id: 0},
      {name: '无效', id: 1},
      {name: '全部', id: 2}
    ]

    if (tempRoute.account && tempRoute.account === 'true') {
      that.catAccountStatus = false
      that.catUserInfo['name'] = tempRoute.name
      that.catUserInfo['team'] = Number(tempRoute.team)
      that.catUserInfo['id'] = tempRoute.accountId
    }
  },
  beforeCreate: function () {
    initLogin(this.$router)
  }
}
</script>

<style scoped>
.page_nav {position: absolute;top: 80px;padding: 20px 0 20px 28px;margin-left: -28px;width: calc(100vw - 272px);background-color: rgba(255, 255, 255, 1)}
.page_nav_full {width: 100%;min-width: 1306px}
.page_nav_content {flex-flow: column;align-items: flex-start;justify-content: flex-start;margin-top: 24px}
.account_info_item {justify-content: flex-start}
.account_info_item:not(:first-of-type) {margin-top: 20px}
.account_info_container {min-width: 260px;justify-content: flex-start}
.account_info_container:not(:first-of-type) {margin-left: 20px}
.account_channel {min-width: 100px}
.account_label {white-space: nowrap}
.account_label_note {width: 160px}
.account_label span {font-size: 12px;font-weight: bold;color: rgba(102, 102, 102, 1)}
.account_info_content {margin-left: 16px}
.account_info_content span {font-size: 14px;font-weight: bold;color: rgba(40, 40, 40, 1)}
.account_page_container {padding: 30px 32px;margin-top: 124px;background-color: rgba(255, 255, 255, 1);border-radius: 6px}
.account_page_header {justify-content: space-between}
.page_wait_time {justify-content: space-between}
.page_wait_time_container {justify-content: flex-start;flex-flow: column;align-items: flex-start}
.page_wait_time .page_wait_time_container:not(:first-of-type) {margin-left: 100px}
.page_wait_time_info span {font-size: 28px;font-weight: 500;color: rgba(40, 40, 40, 1)}
.page_wait_time_label {margin-top: 12px}
.page_wait_time_label span {font-size: 16px;font-weight: 500;color: rgba(48, 48, 48, 1)}
input#range_time {border: none;width: 179px;cursor: pointer;line-height: 32px;padding: 0 10px;display: inline-block;height: 32px;font-size: 14px;font-weight: 400;color: rgba(40, 40, 40, 1)}
.input_container {margin-top: 28px;margin-right: 24px}
.input_container select {width: 224px;height: 32px;line-height: 32px;padding: 0 14px;border: 1px solid rgba(219, 219, 219, 1);border-radius: 4px;font-size: 14px;font-weight: 400;color: rgba(40, 40, 40, 1)}

.account_page_main {margin-top: 20px}
.account_page_main_header {justify-content: flex-start;padding: 0 23px;height: 50px;background-color: rgba(248, 248, 248, 1)}
.account_page_main_header span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.account_page_main_client_container {justify-content: flex-start;padding: 0 23px;width: calc(100% - 46px);height: 50px;border-bottom: 1px solid rgba(235, 235, 235, 1)}
.account_page_main_client_container span {font-size: 14px;font-weight: 500;color: rgba(40, 40, 40, 1)}
.account_page_main_client {width: 630px}
.account_page_main_member {width: 300px;text-align: right}
.account_page_main_list {flex-flow: column;justify-content: flex-start;align-items: flex-start}
.user_identification {margin-left: 16px;background-color: rgba(76, 139, 255, 0.12);padding: 4px 9px;border-radius: 4px}
.account_page_main_client_container span.user_identification {color: rgba(76, 139, 255, 1);font-size: 12px;font-weight: 500}

.no_user_hint {margin: 30px 0;width: 100%}
.no_user_hint span {font-size: 16px;font-weight: 500;color: rgba(143, 143, 143, 1)}
</style>



// WEBPACK FOOTER //
// src/components/page-user/client-from-qr.vue